import cartoons from './assets/print-workflow-cartoons-v1.webp';

// One shared illustration sheet gives all four cards a consistent visual style.
// The image stays intact; CSS displays one quadrant in each feature card.
export function WorkflowCartoon({ scene }: { scene: 'scan' | 'pricing' | 'privacy' | 'queue' }) {
  return <div className={`workflow-cartoon cartoon-${scene}`} aria-hidden="true"><img src={cartoons} width={1536} height={1024} decoding="async" alt="" /></div>;
}
